import {useCallback, useEffect, useState} from 'react';

import styles from '@styles/product/description.module.scss';

const ShortDescription = props => {
	const {text, heightVal, descriptionRef} = props;
	const [data, setData] = useState({
		showLess: false,
		isDisplay: false,
		height: heightVal,
	});

	const showHideDescription = useCallback(() => {
		setData(prev => ({...prev, showLess: !prev.showLess}));
	}, []);

	const showMoreText = (
		<>
			<i className='fas fa-plus'></i> More
		</>
	);
	const showLessText = (
		<>
			<i className='fas fa-minus'></i> Less
		</>
	);

	useEffect(() => {
		const setDescriptionView = () => {
			const height = descriptionRef.current.clientHeight;
			let obj = {};
			if (height > heightVal && height - heightVal > 30) {
				obj['showLess'] = true;
				obj['isDisplay'] = true;
				setData(prev => ({...prev, ...obj}));
			}
		};
		setDescriptionView();
	}, [descriptionRef, heightVal]);

	useEffect(() => {
		if (data.showLess) {
			let obj = {};
			if (heightVal < 100)
				obj['height'] =
					descriptionRef.current?.children[0].children[0].clientHeight;
			else obj['height'] = heightVal;
			setData(prev => ({...prev, ...obj}));
		}
	}, [data.showLess, descriptionRef, heightVal]);

	return (
		<>
			<div
				ref={descriptionRef}
				id='productDesc'
				style={{
					maxHeight: data.showLess ? data.height : '',
				}}
				className={`${data.showLess ? styles.scrRedLess : styles.scrRedMore}`}
			>
				<pre
					className={`${styles.preMsg} ${
						heightVal < 100 && data.showLess ? styles.more : styles.less
					}`}
					dangerouslySetInnerHTML={{
						__html: text,
					}}
				></pre>
				{data.isDisplay && heightVal < 100 && (
					<span
						className={`${styles.moreBt} ${
							data.showLess ? styles.morePosition : styles.lessPosition
						} links`}
					>
						<span onClick={showHideDescription} className='link_type_6'>
							{data.showLess ? showMoreText : showLessText}
						</span>
					</span>
				)}
			</div>
			{data.isDisplay && heightVal > 100 && (
				<span className={`${styles.moreBt} links`}>
					<span onClick={showHideDescription} className='link_type_6'>
						{data.showLess ? showMoreText : showLessText}
					</span>
				</span>
			)}
		</>
	);
};

export default ShortDescription;
